import { jsx as _jsx } from "react/jsx-runtime";
import { NetopsOfflineForm } from './offline-form';
export function NetopsOfflineTab(_a) {
    var permissions = _a.permissions;
    return _jsx(NetopsOfflineForm, { permissions: permissions });
}
